module.exports = __webpack_public_path__ + "static/iphone-whatsapp-b0a0431ad3bc702fe3efbbe961c9e7ab.png";